var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4251 0.471756C13.0529 -0.156069 14.0698 -0.156997 14.6943 0.46746L17.532 3.30529C18.1575 3.93081 18.1559 4.94643 17.5277 5.5745L5.62484 17.4777C5.31142 17.791 4.6953 18.0238 4.25625 17.9981L1.0396 17.8088C0.59704 17.7827 0.217024 17.3994 0.191252 16.9604L0.00198946 13.7435C-0.0240509 13.3011 0.208567 12.6887 0.522274 12.375L12.4251 0.471756ZM4.35061 16.3973C4.33396 16.3962 4.50282 16.3322 4.49101 16.3439L16.3939 4.44061C16.3966 4.43792 13.5604 1.60144 13.5604 1.60144C13.5626 1.60372 1.6562 13.5088 1.6562 13.5088C1.66667 13.4985 1.60385 13.6639 1.60291 13.6494L1.75552 16.2444L4.35061 16.3973ZM12.4279 2.73701L15.2627 5.57188L14.1288 6.70589L11.2941 3.87102L12.4279 2.73701Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.23dd970bcdec800b1717f6451cbf2cf8.svg";
export { ForwardRef as ReactComponent };